import * as React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { trackNewbuildingLayoutsSwitchClick } from './tracking';
import { newbuildingLayoutsOff, newbuildingLayoutsOn } from '../../actions/newbuildingLayouts';
import { Dispatch } from '../../common/state';
import { NewbuildingLayoutsFilter } from '../../components/NewbuildingLayoutsFilter';
import {
  isListingForResidentialComplexSelector,
  residentialComplexLayoutsCurrentCountSelector,
  residentialComplexLayoutsOnSelector,
} from '../../selectors/newbuildingLayouts';
import { useApplicationContext } from '../../utils/applicationContext';
import { makeSearchLayout } from 'shared/actions/searchLayout';
import { selectJsonQuery } from 'shared/selectors/results';

export const NewbuildingLayoutsFilterContainer = () => {
  const { config } = useApplicationContext();
  const dispatch: Dispatch = useDispatch();
  const jsonQuery = useSelector(selectJsonQuery);
  const isSwitcherEnabled = config.get('Newbuilding.LayoutsListingDesktop.Enabled');
  const isListingForResidentialComplex = useSelector(isListingForResidentialComplexSelector);
  const residentialComplexLayoutsCount = useSelector(residentialComplexLayoutsCurrentCountSelector);
  const checked = useSelector(residentialComplexLayoutsOnSelector);

  const newbuildingLayoutsSwitch = React.useCallback(
    (event: React.ChangeEvent<HTMLInputElement>, value: boolean) => {
      if (value) {
        trackNewbuildingLayoutsSwitchClick({ isSwitchOn: true });
        dispatch(newbuildingLayoutsOn());
        dispatch(makeSearchLayout(jsonQuery));
      } else {
        trackNewbuildingLayoutsSwitchClick({ isSwitchOn: false });
        dispatch(newbuildingLayoutsOff());
        dispatch(makeSearchLayout(jsonQuery));
      }
    },
    [dispatch, jsonQuery],
  );

  if (!isSwitcherEnabled || !isListingForResidentialComplex || !residentialComplexLayoutsCount) {
    return null;
  }

  return <NewbuildingLayoutsFilter checked={checked} onChange={newbuildingLayoutsSwitch} />;
};
